import { Component, inject, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CommunityDTO } from 'src/app/DTO/CommunityDTO';
import { CookieConsentService } from 'src/app/services/cookie-consent/cookie-consent.service';
import { API_URL } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  public translate = inject(TranslateService);
  private cookieConsentService = inject(CookieConsentService);

  public apiUrl = API_URL;

  @Input () community?: CommunityDTO;

  openCookiePreferences(): void {
    this.cookieConsentService.showPreferences();
  }
}

